export const GET_CLINIC_LOCATIONS_CONST = 'GET_CLINIC_LOCATIONS_CONST'

export const CLEAR_CLINIC_LOCATIONS = 'CLEAR_CLINIC_LOCATIONS' 